import { useEffect, useRef, useState } from "react";
import ClientInformation from "../ClientInformation";

const GeneralConentForm = () => {
  const [value, setValue] = useState(
    "I am the owner/agent of the pet described above and have the authority to execute this consent. I authorize Vetic Pet Clinic and its staff to perform euthanasia for my pet. The Vetic Pet Clinic staff has informed me about the details of the procedure and the reason for the procedure. I completely agree with the reason for euthanasia being there is no other option to cure him from this sickness. I further realize that I am responsible for the payment of the above procedures. I will take complete responsibility for the disposal of my pet body as per the law of the land.",
  );

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };

  return (
    <div>
      <div>
        <ClientInformation />
      </div>
      <div className="gap-2 flex mt-2">
        <textarea
          ref={textareaRef}
          className="w-full border p-4 text-sm resize-none print:hidden"
          value={value} // Controlled component to retain content
          onChange={(e) => setValue(e.target.value)}
          onInput={adjustHeight}
          style={{
            overflowY: "auto",
            scrollbarWidth: "thin",
          }}
        />
        <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value}</div>
      </div>

      <div className="gap-2 flex  items-center w-full pt-10">
        <p className="text-xs">Signature of Pet Owner</p>
      </div>
      <p className="pt-3 font-bold italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default GeneralConentForm;
